/* eslint-disable camelcase */
import React from 'react';

type TAgentCostBreakDownProps = {
    duration: number;
    number_of_freelancers: number;
    client_pay_per_hour: number | '';
}

export default function AgentCostBreakDown({
    client_pay_per_hour,
    duration,
    number_of_freelancers,
}: TAgentCostBreakDownProps) {

    const totalCostPerBooking = client_pay_per_hour ? client_pay_per_hour * duration : 0;
    const totalCost = totalCostPerBooking * number_of_freelancers;
    const vatRate = 0.2;

    return (
        <div className="cost-breakdown">
            <span>
                Total cost: <strong>£{totalCost.toFixed(2)}</strong>{' '}
                (plus £{(totalCost * vatRate).toFixed(2)} VAT)
            </span>
        </div>
    );
}
